const QRCode = require('qrcode');

class SignedLinkSummaryCtrl {
  constructor($sce, $window, $timeout, UrlClipCopy) {
    'ngInject';
    this.$sce = $sce;
    this.$window = $window;
    this.$timeout = $timeout;
    this.ucc = UrlClipCopy;
    this.qrUrl = null;
  }

  $onInit() {
    this.refreshShareTools();
  }

  $onChanges(changes) {
    if (changes.summary) this.refreshShareTools();
  }

  get locationLabel() {
    if (this.summary?.type === 'generate' || this.summary?.type === 'import' || this.summary?.type === 'url') {
      return 'Location';
    }
    return 'Launch Table';
  }

  get locationValue() {
    if (this.summary?.type === 'generate') {
      const table = this.summary?.hostTableName || '';
      return table ? `Document Generation (${table})` : 'Document Generation';
    }
    if (this.summary?.type === 'import') {
      const table = this.summary?.hostTableName || '';
      return table ? `Automatic Record Import (${table})` : 'Automatic Record Import';
    }
    return this.summary?.type === 'url' ? 'URL' : (this.summary?.hostTableName || '');
  }

  get providerUrlLabel() {
    if (this.summary?.type === 'generate' || this.summary?.type === 'import') {
      return 'Webhook URL';
    }
    return 'Field URL';
  }

  get showShareTools() {
    return !!(this.summary?.type === 'url' && this.summary?.shareUrl);
  }

  async refreshShareTools() {
    this.qrUrl = null;
    if (!this.showShareTools) return;
    try {
      const dataUrl = await QRCode.toDataURL(this.summary.shareUrl);
      this.$timeout(() => {
        this.qrUrl = this.$sce.trustAsResourceUrl(dataUrl);
      });
    } catch (_e) {
      this.qrUrl = null;
    }
  }

  previewShareUrl() {
    if (!this.summary?.shareUrl) return;
    this.$window.open(this.summary.shareUrl, '_blank', 'noopener,noreferrer');
  }

  copyShareUrl() {
    if (!this.summary?.shareUrl) return;
    this.ucc.copy(this.summary.shareUrl);
  }

  async copyShareQr() {
    if (!this.summary?.shareUrl) return;
    const label = (this.summary.label || 'Link').trim();
    const filename = `Submit ${label} qr.png`;
    const dataUrl = await QRCode.toDataURL(this.summary.shareUrl);
    this.ucc.copyImg(dataUrl, filename);
  }

  qrDownloadName() {
    const label = (this.summary?.label || 'Link').trim();
    return `Submit ${label} qr.png`;
  }
}

export default {
  bindings: {
    summary: '<',
    shareOnly: '<',
  },
  templateUrl: 'form-builder/build-wizard/signed-link-summary/signed-link-summary.component.html',
  controller: SignedLinkSummaryCtrl,
};
